import axios from "axios";
const API_DETAIL_LISTING = "https://iudi-api.thinkdiff.us/api/listings";
const API_LISTINGS_BY_USER = "https://iudi-api.thinkdiff.us/api/listings_by_user";
const API_LISTINGS_FILTER = "https://iudi-api.thinkdiff.us/api/listings/filter";

export default async function getDetailListing(id) {
    try {
        const response = await axios.get(`${API_DETAIL_LISTING}/${id}`);
        //là object
        return response.data;
    } catch (error) {
        console.error("Error fetching detail listing:", error);
        throw error;
    }
}

// Lấy danh sách sản phẩm khác của người bán
export async function getProductsBySellerId(sellerId, page = 1) {
    try {
        const response = await axios.get(`${API_LISTINGS_BY_USER}/${sellerId}?page=${page}`);
        // Trả về mảng data
        return response.data.data || [];
    } catch (error) {
        console.error("Error fetching products by seller:", error);
        return [];
    }
}

// Lấy danh sách sản phẩm tương tự theo CategoryId
export async function getSimilarProducts(categoryId, page = 1) {
    try {
        const response = await axios.get(`${API_LISTINGS_FILTER}?CategoryId=${categoryId}&page=${page}`);
        // Trả về mảng data
        return response.data.data || [];
    } catch (error) {
        console.error("Error fetching similar products:", error);
        return [];
    }
}